import { render, staticRenderFns } from "./HoatDong.vue?vue&type=template&id=35d87cc2&scoped=true&"
import script from "./HoatDong.vue?vue&type=script&lang=js&"
export * from "./HoatDong.vue?vue&type=script&lang=js&"
import style0 from "./HoatDong.vue?vue&type=style&index=0&id=35d87cc2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d87cc2",
  null
  
)

export default component.exports